var map = {
	"./selection0.png": 3452,
	"./selection1.png": 272,
	"./selection10.png": 5064,
	"./selection11.png": 6936,
	"./selection2.png": 7188,
	"./selection3.png": 5004,
	"./selection4.png": 12,
	"./selection5.png": 5416,
	"./selection6.png": 5340,
	"./selection7.png": 8232,
	"./selection8.png": 1708,
	"./selection9.png": 4908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9024;